<template>
    <div id="about" class="about">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <h2>About</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5">
                    <div class="about__content" v-html="aboutText">{{aboutText}}</div>
                </div>
                <div class="col-md-5 offset-md-1">
                    <img class="about__image" :src="aboutImage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let ax = axios.create({
        baseURL: 'http://hessestudios.de/wp/wp-json/wp/v2/pages/7'
    });
    let axMedia = axios.create({
        baseURL: "http://hessestudios.de/wp/wp-json/wp/v2/media/79"
    });

    export default {
        name: 'About',
        data(){
            return {
                aboutText : "",
                aboutImage : ""
            };
        },
        mounted(){
            ax.get().then(response => {
                this.aboutText = response.data.content.rendered;
            });

            axMedia.get().then(response => {
                this.aboutImage = response.data.guid.rendered;
            });
        }
    }
</script>


<style lang="scss">
    @import "../assets/styles/components/about.scss";
</style>